export default __webpack_public_path__ + "static/2-c20d39b5add9f9ee0b47818b5fd6612f.png";